<!-- 公司案例内容等列表页 -->
<template>
	<div id="aboutUsList">
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<div class="aboutUsList">
			<!-- 导航列表 -->
			<div class="navList">
				<ul>
					<li v-for="(item,index) in navList" :key="index" :class="{'activeBg':activeIndex == index}"
						@click="activeLink(index)">
						{{item.name}}
					</li>
				</ul>
			</div>
			<div style="width: 1200px;background-color: #fff;min-height:600px;margin-bottom:50px;">
				<router-view></router-view>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			Footer
		},
		data() {
			return {
				activeIndex:0,
				navList: [{
						name: '公司介绍',
						linkUrl: '/companyIntroduction'
					},
					{
						name: '成功案例',
						linkUrl: '/successCase'
					},
					{
						name: '社会责任',
						linkUrl: '/socialResponsibility'
					},
					{
						name: '人才招聘',
						linkUrl: '/recruit'
					},
					{
						name: '发展历程',
						linkUrl: '/developmentHistory'
					}
				],
			}
		},
		mounted() {
			let vm = this
			if(vm.$route.query.index){
				vm.activeLink(vm.$route.query.index)
			}else{
				vm.activeIndex = window.sessionStorage.getItem('aboutUsIndex') || 0
			}
		},
		methods: {
			activeLink(index) {
				let vm = this
				vm.activeIndex = index
				vm.$store.commit('activeAboutUsIndex',vm.activeIndex)
				vm.$router.push(vm.navList[vm.activeIndex].linkUrl)
			}
		},
	}
</script>

<style scoped>
	#aboutUsList{
		background-color: #f9f9f9;
	}
	.aboutUsList{
		width: 1200px;
		margin: 0 auto;
	}
	.aboutUsList .navList {
		width: 1200px;
		height: 70px;
	}
	.aboutUsList .navList ul {
		line-height: 70px;
		position: relative;
		left: -20px;
	}
	.activeBg {
		background-color: #c32a1a;
		color: #fff;
	}
	.aboutUsList .navList ul li {
		display: inline-block;
		width: 100px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		margin-right: 20px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>
